import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Accordion, Icon, Menu } from "semantic-ui-react";

const MainMenuItem = ({ props, item, itemIndex }) => {
  const { onSubmit, collapsed } = props;
  const onItemClick = (_, { name }) => onSubmit(name);

  const { complianceOnly } = useSelector((state) => state.logIn);

  // useState for controlling visual accordion folding locally
  const [activeIndices, setActiveIndices] = useState(
    complianceOnly ? [9, 10] : [10],
  );

  const onAccordionClick = (_e, titleProps) => {
    const { index } = titleProps;
    if (activeIndices.includes(index)) {
      setActiveIndices(activeIndices.filter((i) => i !== index));
    } else {
      setActiveIndices([...activeIndices, index]);
    }
  };

  // If there are submenus, use foldable accordion
  if (item?.menu && item?.menu?.length > 0) {
    const level2Menus = item?.menu?.map((x) => {
      return (
        <Menu.Item
          className="pl-0_85"
          key={x.code}
          name={x.code}
          onClick={onItemClick}
        >
          <Icon name={x.icon ? x.icon : "area graph"} />
          {collapsed ? "" : x.name}
        </Menu.Item>
      );
    });

    return (
      <Menu.Item
        className={collapsed ? "px-0 pb-1_5" : "pb-1_5 pr-0_85"}
        key={item.code}
      >
        <Accordion.Title
          active={activeIndices.includes(itemIndex)}
          index={itemIndex}
          onClick={onAccordionClick}
          className={collapsed ? "" : "justify-between"}
        >
          {collapsed ? "" : item.name}
          <Icon name={item.icon ? item.icon : "area graph"} />
        </Accordion.Title>
        <Accordion.Content
          active={activeIndices.includes(itemIndex)}
          content={level2Menus}
        />
      </Menu.Item>
    );
  }

  // Otherwise, use normal menu item
  return (
    <Menu.Item
      color="black"
      key={item.code}
      name={item.code}
      inverted="true"
      onClick={onItemClick}
    >
      {!collapsed && item.name}
      <Icon name={item.icon ? item.icon : "area graph"} />
    </Menu.Item>
  );
};

export default MainMenuItem;
